import { render, staticRenderFns } from "./WineryGeneral_Desktop.vue?vue&type=template&id=f0ba052a&scoped=true&"
import script from "./WineryGeneral_Desktop.vue?vue&type=script&lang=js&"
export * from "./WineryGeneral_Desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ba052a",
  null
  
)

export default component.exports